// Percorso file: src/pages/home/HomeGuest.jsx
//
// HOME DI SOLA CLINIC — il ruolo GUEST (cantiere CLINICS, fetta A,
// 12/9/2026; DISEGNO v2 §7).
//
// Il GUEST è il tutore autenticato del mondo clinic (o, dalla G1, l'adulto
// che si è iscritto da sé): senza tessera di stagione, senza alcun potere
// nel mondo dei soci. Questa è la sua unica destinazione.
//
// ⚠️ DALLA FETTA G2 (24/9/2026) È LA PAGINA DELLE CLINIC, non più un testo
// vuoto: lo STESSO componente di /clinics (ClinicMember), non una copia — gli
// eventi aperti, le sue righe (sé stesso se è un adulto ospite, i suoi
// bambini se è un genitore ospite), «Enrol» e, sulle righe ENROLLED, il
// «Calendar». Montato con `home`: nessun «Back», perché dietro non c'è
// nulla; resta la barra utente col Logout, come prima.
//
// L'accesso alla pagina è deciso da RequireRole in App.jsx
// (`role="GUEST"`), come per ogni altra home: la pagina è solo contenuto.
// Che cosa l'ospite vede e iscrive lo decidono le rotte /clinic-member/* del
// server.

import React from "react";
import ClinicMember from "../ClinicMember";

const HomeGuest = () => <ClinicMember home />;

export default HomeGuest;
